import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Robotics = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/learning-app.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Robotics Lab"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Robotics</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Labs</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="" href="/mathmatics">
                      Mathematics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/physics">
                      Physics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/biology">
                      Biology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/chemistry">
                      Chemistry
                    </a>
                  </li>
                  <li>
                    <a class="" href="/language">
                      Language
                    </a>
                  </li>
                  <li>
                    <a class="" href="/computer">
                      Computer
                    </a>
                  </li>
                  <li>
                    <a class="inc-tlink-active" href="/robotics">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/hands-on-studio">
                      Hands On Studio
                    </a>
                  </li>
                  <li>
                    <a class="" href="/psychology">
                      Psychology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/counseling-sen">
                      Counseling &amp; Sen{" "}
                    </a>
                  </li>
                </ul>
              </div>
              <h5 className="text-center color-red">
                <small>
                  "What a computer is to me is the most remarkable tool that we
                  have ever come up with. It's the equivalent of a bicycle for
                  our minds." - <i>Steve Jobs</i>
                </small>
              </h5>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/robotics-lab.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>

              <p>
                Education in the 21st century focuses on the 4 C's -{" "}
                <b>Creativity, Communication, Collaboration</b> and{" "}
                <b>Critical Thinking.</b> We, at Lotus Valley International
                School, Gurgaon, recognize the contribution of another C, C for
                Computers, towards the multi-faceted evolution of the learners
                into responsible and empowered global citizens of tomorrow. Use
                of technology not only enhances learning but also provides even
                the youngest of learners with early knowledge of requisite job
                skills from typing and basic research to design and coding.
              </p>
              <p>
                To impart relevant IT knowledge to the learners and to provide
                them with the much needed hands-on experience in the subject,
                the school has three state-of-the-art IT Labs which are capable
                of accommodating around 100 learners at any given time. The
                systems are regularly upgraded to ensure the latest software are
                in place to match pace with the rapidly changing times and to
                provide our learners the opportunity to learn and use the best
                that is available to them.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Robotics;
